import { Injectable } from '@angular/core';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Utilities_ShellService } from './Utilities.shell.service';
import { Utilities_OperationService } from './Utilities.operation.service';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.service';
import { Utilities_ReportService } from './Utilities.report.index';
import { Utilities_LocalizationService } from './Utilities.localization.service';
import { Utilities_format_username_frontflow_ComponentContextService } from './Utilities.format_username_frontflow.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './Utilities.frontend.types'
import { $frontendTypes as $types} from './Utilities.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { BaseComponent } from './components/base.component';

@Injectable({ providedIn: 'root' })
export class Utilities_format_username_frontflowService {


  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Utilities_ShellService,
    private $datasources: Utilities_DatasourceService,
    private $flows: Utilities_FlowService,
    private $frontendFlows: Utilities_FrontendFlowService,
    private $reports: Utilities_ReportService,
    private $localization: Utilities_LocalizationService,
    private $operations: Utilities_OperationService,
    private $context: Utilities_format_username_frontflow_ComponentContextService,
    ) {
  }

  async run($inParams: { inUserName: string }): Promise<{ outUserName?: string, reasons?: string[] }>
  {
    
    const $shell = this.$shell;
    const $datasources = this.$datasources;
    const $flows = this.$flows;
    const $frontendFlows = this.$frontendFlows;
    const $reports = this.$reports;
    const $settings = this.$settings;
    const $operations = this.$operations;
    const $utils = this.$utils;
    const $context = this.$context;
    
    
    const $flow: { inParams: { inUserName: string }, outParams: { outUserName?: string, reasons?: string[] } } = {
    inParams: $inParams,
    outParams: { outUserName: null, reasons: [] }
    };


    try {
    let userName = $flow.inParams.inUserName;

    $flow.outParams.outUserName = spliceIt(userName);

}
catch (error) {
    let targetError = error;

    while ($utils.isDefined(targetError.error)) {
        targetError = targetError.error;
    }

    addReason(targetError.message);
}

/********************************************************
 * FUNCTIONS
*********************************************************/
function addReason(reason: string) {
    if (!$utils.isDefined($flow.outParams.reasons)) {
        $flow.outParams.reasons = [];
    }

    $flow.outParams.reasons.push(reason);
}

function spliceIt(spliceValue: string){
  if (spliceValue.includes('@')){
    spliceValue = spliceValue.split('@').splice(0,1).toString()
  }
  else {
    spliceValue = spliceValue.split("\\").splice(1).toString()
  }
  return spliceValue
}


    
    return $flow.outParams;
  }
}

